import { useSelector } from 'react-redux';

function AppHeadNave({ setShedulTab }) {
  const { user } = useSelector((store) => store.auth);
  const { defaultSchedulerTab } = useSelector((store) => store.app);
  const aptView = user?.glsstsettins?.ch_default_appointment_tab === '1';
  return (
    <section className="home-body">
      {aptView ? (
        <>
          <div
            className={
              'first-tab ' +
              (defaultSchedulerTab === 'aptOpen' ? 'first-tab-active' : '')
            }
            onClick={() => setShedulTab('aptOpen')}
            style={{ flexBasis: '13%' }}
          >
            Open Appt.
          </div>
          <div
            className={
              'first-tab ' +
              (defaultSchedulerTab === 'aptClose' ? 'first-tab-active' : '')
            }
            onClick={() => setShedulTab('aptClose')}
            style={{ flexBasis: '13%' }}
          >
            Completed Appt.
          </div>
        </>
      ) : (
        <div
          className={
            'first-tab ' +
            (defaultSchedulerTab === 'app' ? 'first-tab-active' : '')
          }
          onClick={() => setShedulTab('app')}
          style={{ flexBasis: '16%' }}
        >
          Appointments
        </div>
      )}

      <div
        className={
          'first-tab ' +
          (defaultSchedulerTab === 'cal' ? 'first-tab-active' : '')
        }
        onClick={() => setShedulTab('cal')}
        style={aptView ? { flexBasis: '13%' } : { flexBasis: '16%' }}
      >
        Calendar
      </div>
      <div
        className={
          'first-tab ' +
          (defaultSchedulerTab === 'task' ? 'first-tab-active' : '')
        }
        onClick={() => setShedulTab('task')}
        style={aptView ? { flexBasis: '13%' } : { flexBasis: '16%' }}
      >
        Task
      </div>
      <div
        className={
          'first-tab ' +
          (defaultSchedulerTab === 'sumry' ? 'first-tab-active' : '')
        }
        onClick={() => setShedulTab('sumry')}
        style={aptView ? { flexBasis: '13%' } : { flexBasis: '16%' }}
      >
        Summary
      </div>
      <div
        className={
          'first-tab ' +
          (defaultSchedulerTab === 'todo' ? 'first-tab-active' : '')
        }
        onClick={() => setShedulTab('todo')}
        style={aptView ? { flexBasis: '13%' } : { flexBasis: '16%' }}
      >
        To Do
      </div>
    </section>
  );
}

export default AppHeadNave;
